<ng-container *ngIf="loading$ | async">
    <div class="overlay"></div>
    <mat-progress-spinner mode="indeterminate" diameter="65"></mat-progress-spinner>
</ng-container>